import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import TypeLabel from '../../TypeLabel';
import StyledItem from '../../StyledItem';
import Heading from '../../Heading';
import { getActiveSite } from '../../../bundles/sites';
import {
  getRoleNotificationConfigs,
  getUserNotificationConfigs,
  requestUserNotificationConfigs,
} from '../../../bundles/notification-config';
import { requestMembers, getMembers } from '../../../bundles/auth';
import { isConfigCustom } from './constants';

import './NotificationView.scss';

const NotificationLandingView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const site = useSelector(getActiveSite);
  const roleConfigs = useSelector(getRoleNotificationConfigs);
  const userConfigs = useSelector(getUserNotificationConfigs);
  const siteMembers = useSelector((state) => getMembers(state, `site/${site?.id}`));

  useEffect(() => {
    if (site?.id) {
      dispatch(requestMembers(`site/${site.id}`));
      dispatch(requestUserNotificationConfigs({ org: site.org, site: site.id }));
    }
  }, [dispatch, site?.id, site?.org]);

  const { customRoles, customUsers } = useMemo(() => {
    if (siteMembers.length === 0) return { customRoles: 0, customUsers: 0 };
    const memberMap = new Map(siteMembers.map((m) => [m.id, m.type]));
    const customRoleCount = roleConfigs.filter((c) =>
      isConfigCustom(memberMap.get(c.role) || c.role, c)
    ).length;
    return { customRoles: customRoleCount, customUsers: userConfigs.length };
  }, [roleConfigs, userConfigs, siteMembers]);

  const navigateToTransformerAlarms = () => {
    navigate({
      pathname: `/sites/${site.id}/admin/notifications/transformer-alarms`,
      search: globalThis.location.search,
    });
  };

  return (
    <div className="notification-landing-view">
      <Heading contentLeft={<div className="title">Notifications</div>} />
      <StyledItem
        itemClass="notification-list-item"
        onClick={navigateToTransformerAlarms}
        headerLabel={<div className="notification-list-item__label">Transformer Alarms</div>}
        headerContent={
          <div className="notification-list-item__tags">
            {customRoles > 0 && (
              <TypeLabel
                text={`${customRoles} custom role${customRoles !== 1 ? 's' : ''}`}
                color="grey"
              />
            )}
            {customUsers > 0 && (
              <TypeLabel
                text={`${customUsers} custom user${customUsers !== 1 ? 's' : ''}`}
                color="grey"
              />
            )}
          </div>
        }
      />
    </div>
  );
};

export default NotificationLandingView;
